import { render, staticRenderFns } from "./constituent.vue?vue&type=template&id=2802fc76&scoped=true&"
import script from "./constituent.vue?vue&type=script&lang=js&"
export * from "./constituent.vue?vue&type=script&lang=js&"
import style0 from "./constituent.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./constituent.vue?vue&type=style&index=1&id=2802fc76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802fc76",
  null
  
)

export default component.exports